export default __webpack_public_path__ + "static/media/water.aecec781.svg";